module.exports = {
    apiURL: process.env.VUE_APP_API_URL,
    recaptchaKey : process.env.VUE_APP_RECAPTCHA,
    env: process.env.VUE_APP_ENV,
    appName: process.env.VUE_APP_APP_NAME
  }
  